import React, { useMemo } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useQuery } from '@tanstack/react-query';
import { createQueryString } from '../../../../../lib/utils';
import { fetchTestCasesPassFailInTestCycle } from '../../../../../modules/dashboard';
import ChartTitle from '../../../../elements/ChartTitle';
import NoDataAvailable from './NoDataAvailable';
import { Spinner } from 'react-bootstrap';

const GRAPH_TITLE = 'Test Cases Pass/Fail in Test Cycles';
const TestCasesPassFailInTestCycle = ({ projectId, dateFilters }) => {
  const queryString = createQueryString(dateFilters);

  const {
    data: response,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['testCasesPassFailInCycle', projectId, queryString],
    queryFn: () => fetchTestCasesPassFailInTestCycle(projectId, queryString),
    enabled: !!projectId,
  });

  const finalData = useMemo(() => {
    const rawData = response?.data || [];
    return rawData
      .filter(
        (testCycle) =>
          parseInt(testCycle.pass_count) > 0 || parseInt(testCycle.fail_count) > 0
      )
      .map((item) => ({
        name: item.key,
        Pass: parseInt(item.pass_count, 10),
        Fail: parseInt(item.fail_count, 10),
      }));
  }, [response]);

  return (
    <div className="chart-div">
      <ChartTitle title={GRAPH_TITLE} dateFilters={dateFilters} />
      {isLoading ? (
        <Spinner className="mt-5" />
      ) : finalData?.length === 0 || error ? (
        <NoDataAvailable />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={finalData}
            barSize={25}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              label={{
                value: 'Test Cycles',
                position: 'insideBottom',
                offset: -10,
              }}
              tick={{ fontSize: 12 }}
            />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend wrapperStyle={{ padding: 10 }} />
            <Bar dataKey="Pass" stackId="a" fill="#008000" />
            <Bar dataKey="Fail" stackId="a" fill="#B22222" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default TestCasesPassFailInTestCycle;
